module.exports = __webpack_public_path__ + "static/06-3843c6934d2be6f2003e63ec082034c8.jpg";